var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ToggleSwitch"
  }, [_c('label', {
    staticClass: "ToggleSwitch-label",
    class: {
      'ToggleSwitch-label--editable': _vm.isEditable
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkedValue,
      expression: "checkedValue"
    }],
    staticClass: "ToggleSwitch-input",
    attrs: {
      "disabled": !_vm.isEditable,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.checkedValue,
      "checked": Array.isArray(_vm.checkedValue) ? _vm._i(_vm.checkedValue, _vm.checkedValue) > -1 : _vm.checkedValue
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.checkedValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.checkedValue,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.checkedValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.checkedValue = $$c;
        }
      }, _vm.switchValue]
    }
  }), _c('span', {
    staticClass: "ToggleSwitch-slider",
    class: {
      'ToggleSwitch-slider--editable': _vm.isEditable
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }